import React, { Component } from 'react';
import { FormGroup, Row, Col, Label, Input, FormText } from 'reactstrap';

export default class CommunityActivites extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Organization</Label>
                            <Input name='organization' required maxLength="50" value={this.props.item.organization || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Responsibilities</Label>
                            <Input name='responsibilities' required maxLength="100" value={this.props.item.responsibilities || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Start Date</Label>
                            <Input type="date" required name='startDate' value={this.props.item.startDate || ''} onChange={this.props.onChange} max="9999-12-31"/>
                            <FormText color="muted">Format: mm/dd/yyyy</FormText>
                        </FormGroup>
                    </Col>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>End Date</Label>
                            <Input type="date" name='endDate' value={this.props.item.endDate || ''} onChange={this.props.onChange} max="9999-12-31"/>
                            <FormText color="muted">Format: mm/dd/yyyy</FormText>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}